import React, { FC } from 'react';
import { SVGCIconProps } from '../SVGCIcon';

const Mail: FC<SVGCIconProps> = (props) => {
    const { color = 'white', height = 29, width = 29 } = props;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 29 29" fill="none">
            <path
                d="M5.20524 23.5625C4.59483 23.5625 4.07817 23.351 3.65525 22.9281C3.23233 22.5052 3.02087 21.9885 3.02087 21.3781V7.62186C3.02087 7.01145 3.23233 6.49479 3.65525 6.07187C4.07817 5.64896 4.59483 5.4375 5.20524 5.4375H23.7948C24.4053 5.4375 24.9219 5.64896 25.3448 6.07187C25.7677 6.49479 25.9792 7.01145 25.9792 7.62186V21.3781C25.9792 21.9885 25.7677 22.5052 25.3448 22.9281C24.9219 23.351 24.4053 23.5625 23.7948 23.5625H5.20524ZM14.5 15.1739L4.83337 8.99272V21.3781C4.83337 21.4867 4.86821 21.5758 4.9379 21.6455C5.00758 21.7152 5.09669 21.75 5.20524 21.75H23.7948C23.9034 21.75 23.9925 21.7152 24.0622 21.6455C24.1319 21.5758 24.1667 21.4867 24.1667 21.3781V8.99272L14.5 15.1739ZM14.5 13.2917L23.9809 7.25H5.01916L14.5 13.2917ZM4.83337 8.99272V7.25V21.3781C4.83337 21.4867 4.86821 21.5758 4.9379 21.6455C5.00758 21.7152 5.09669 21.75 5.20524 21.75H4.83337V8.99272Z"
                fill={color}
            />
        </svg>
    );
};

export default Mail;
